import React from 'react';
import { connect } from 'react-redux'

import { Router, Route, Switch } from 'react-router-dom';

import './App.css';

import EventList from './components/events/EventList'
import EventCreate from './components/events/EventCreate';
import EventEdit from './components/events/EventEdit';
import EventShow from './components/events/EventShow';
import EventResults from './components/events/EventUploadResults';
import EventHands from './components/events/EventUploadHands';
import EventImage from './components/events/EventUploadImage';
import Results from './components/events/Results';
import Header from './components/header/Header';
import history from './history'
import EventPage from './components/events/EventPage';
import NoMatch from './components/events/NoMatch';
import ResultDetails from './components/events/ResultDetails';
import News from './components/news/News';
import Login from './components/header/Login';
import Contact from './components/header/Contact';
import ReactGA from 'react-ga';
import Logout from './components/header/Logout';

import * as actions from './actions/index'
import Events from './components/events/Events';
import Register from './components/registration/Register';
import Registered from './components/events/Registered';
import EventWinners from './components/events/EventUploadWinners';

class App extends React.Component {
  state = { errorMessage: '', bridgeEvents: [] , selectedEvent: null}

  componentDidMount(){
    ReactGA.initialize('UA-137825974-1');

    ReactGA.pageview(window.location.pathname + window.location.search);

    this.props.onTryAutoSignup();
    this.props.loadWinners();
    this.props.loadEvents();
  }

  render() {
    return (
      <div>
        <Router history={history}>
          <Header isAuthenticated={this.props.isAuthenticated} />
          <Switch>
            <Route exact path="/" component={EventShow} />
            <Route exact path="/news" component={News} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/events/new" component={EventCreate} />
            <Route exact path="/login" component={Login} />
            <Route
              exact
              path="/register/:eventId/:event_date"
              component={Register}
            />
            <Route
              exact
              path="/registered/:eventId/:event_date"
              component={Registered}
            />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/events/list" component={EventList} />
            <Route exact path="/events" component={Events} />
            <Route exact path="/events/results" component={Results} />
            <Route
              exact
              path="/resultDetails/:resultId/:eventId/:event_date"
              component={ResultDetails}
            />
            <Route
              exact
              path="/events/edit/:eventId/:event_organizer"
              component={EventEdit}
            />
            <Route
              exact
              path="/events/results/:eventId/:event_organizer"
              component={EventResults}
            />
            <Route
              exact
              path="/events/results/:eventId/:event_organizer"
              component={EventResults}
            />
            <Route
              exact
              path="/events/hands/:eventId/:event_organizer"
              component={EventHands}
            />
            <Route
              exact
              path="/events/image/:eventId/:event_organizer"
              component={EventImage}
            />
            <Route
              exact
              path="/events/winners/:eventId/:event_organizer"
              component={EventWinners}
            />
            <Route
              exact
              path="/event/show/:eventId/:event_organizer"
              component={EventPage}
            />
            <Route component={NoMatch} />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    winners: state.winners,
    events: state.events,
    isAuthenticated: state.auth.token !== null
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    loadEvents: () => dispatch(actions.fetchEvents()),
    loadWinners: () => dispatch(actions.fetchWinners())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
